import type { GQL_ID } from '@@partner:types:graphql'

import React, { useCallback } from 'react'
import { useAvailableShopsQuery } from '@@partner:graphql/query/catalog/availableShops.gql'

import { CheckPicker, Form, Message } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

export interface MultipleShopPickerProps {
  value?: GQL_ID[]
  onChange?: (selectedShopIds: GQL_ID[]) => void
  label?: string
  placeholder?: string
  disabled?: boolean
  loading?: boolean
  error?: string
  helpText?: string
  required?: boolean
  className?: string
}

export default function MultipleShopPicker ({
  value = [],
  onChange,
  label = 'Магазины',
  placeholder = 'Выберите магазины',
  disabled = false,
  loading = false,
  error,
  helpText,
  required = false,
  className
}: MultipleShopPickerProps) {
  const { data, error: queryError, loading: queryLoading } = useAvailableShopsQuery()

  const handleShopsChange = useCallback(
    (ids = []) => {
      onChange?.(ids)
    },
    [ onChange ]
  )

  if (queryError) {
    return (
      <GraphQLCommonErrorDisplay
        title="Не удалось загрузить список магазинов"
        error={queryError}
      />
    )
  }

  return (
    <Form.Group className={className}>
      <Form.ControlLabel>
        {label}
        {required && ' *'}
      </Form.ControlLabel>
      
      <CheckPicker
        value={value}
        data={data?.shops ?? []}
        onChange={handleShopsChange}
        searchable={true}
        placeholder={placeholder}
        valueKey='id'
        labelKey='address'
        disabled={disabled || loading || queryLoading}
        block
      />
      
      {helpText && (
        <Message type="info" showIcon={false} className="mt-2">
          {helpText}
        </Message>
      )}
      
      {error && (
        <Message type="error" showIcon={false}>
          {error}
        </Message>
      )}
    </Form.Group>
  )
}
